import {effect, inject, Injectable, signal} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Base} from './rich-results';

const CONTEXT = 'https://schema.org';

@Injectable({
  providedIn: 'root',
})
export class RichResultsService {

  private readonly document = inject(DOCUMENT);
  private readonly registry = signal<Base[]>([]);

  readonly jsonLd = effect(() => {
    const docs = this.registry().map(item =>
      JSON.stringify({'@context': CONTEXT, ...item}, null, 2)
    );

    this.renderScripts(docs);
    return docs;
  });

  register(data: Base): void {
    this.registry.update(current => [...current, data]);
  }

  unregister(type: Base['@type']): void {
    this.registry.update(current =>
      current.filter(x => x['@type'] !== type)
    );
  }

  clear(): void {
    this.registry.set([]);
  }

  private renderScripts(jsonStrings: string[]): void {
    if (!this.document) return;

    const previous = Array.from(
      this.document.querySelectorAll('script[data-ld="json-ld"]')
    );
    previous.forEach(el => el.remove());

    jsonStrings.forEach(str => {
      const script = this.document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-ld', 'json-ld');
      script.textContent = str;
      this.document.head.appendChild(script);
    });
  }
}
